<template>
  <b-modal ref="evaluationOrder"
           size="xl"
           :hide-footer="true"
           scrollable>
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.EvaluationOrder.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div class="d-flex flex-wrap h-100">
      <ag-grid-vue class="ag-theme-alpine"
                   :getLocaleText="localeTextFunc"
                   :defaultColDef="defaultColumnDef"
                   :gridOptions="evaluationOrderGridOptions"
                   :columnTypes="columnTypes"
                   :columnDefs="columnDefs"
                   :rowData="data"
                   :suppressContextMenu="true"
                   :stopEditingWhenCellsLoseFocus="true"
                   :groupHeaderHeight="45"
                   :headerHeight="45"
                   :rowHeight="30"
                   style="width:100%;height:100%;"
          >
      </ag-grid-vue>
    </div>
  </b-modal>
</template>

<script>
import ZSistemaRepository from '@/shared/http/repositories/business/zsystem'
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../../mixins/gridMixin'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'EvaluationOrder',
  components: {
    AgGridVue
  },
  mixins: [gridMixin],
  data () {
    return {
      data: [],
      evaluationOrderGridOptions: {},
      columnDefs: [
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Order,
          field: 'ordem',
          width: 90
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Request,
          field: 'pedido',
          width: 90
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.IssueDate,
          field: 'dataEmissao',
          type: 'dateColumn',
          width: 90
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Subsidiary,
          field: 'filial',
          width: 90
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Responsible,
          field: 'responsavel',
          width: 150
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Buyer,
          field: 'comprador',
          width: 150
        },
        {
          headerName: this.$lang.PCI.EvaluationOrder.Datatable.Conformed,
          field: 'conforme',
          type: 'booleanColumn',
          width: 90
        }
      ]
    }
  },
  methods: {
    show (obraID) {
      loading.push()
      ZSistemaRepository.GetAllEvaluationOrder(obraID)
        .then(response => {
          if (response.data.code > 0) {
            this.data = response.data.data
            this.$refs.evaluationOrder.show()
            this.$nextTick(() => {
              this.evaluationOrderGridOptions.api.sizeColumnsToFit()
            })
          }
        })
        .finally(() => loading.close())
    },
    onClose () {
      this.$refs.evaluationOrder.hide()
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/evaluationorder/evaluationorder.vue